<div class="container-fluid">
    <div class="row">
        <div class="col-md-7 col-xs-12 padtop3 textCenter marbot110px">
            <h2 class="wlcmMsg">Welcome to</h2>
            <img src="" id="companyLogo" alt="Logo">
            <img class="signInImg" src="../../../assets/images/login-wlc.svg" alt="Forgot pwd page image">
        </div>
        <div class="col-md-5 col-xs-12 backgroundWhite marbot110px">
            <div class="card noBorder">
                <div class="card-body">
                    <h4 class="card-title" style="font-weight: 600;">Forgot Password</h4>
                    <form [formGroup]="fgtPwdForm" class="martop20px">
                        <div class="row">
                            <div class="form-group col-md-8 col-xs-12">
                                <label for="emailId">We'll send a recovery link to</label>
                                <input type="email" class="form-control inputField" formControlName="emailId" id="emailId" placeholder="Enter Email ID" [ngClass]="{'is-invalid': (submitted || form.emailId.dirty) && form.emailId.errors}"
                                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$">
                                <div class="invalid-feedback" *ngIf="(submitted || form.emailId.dirty) && form.emailId.errors">
                                    <span *ngIf="form.emailId.errors.required">Please enter Email</span>
                                    <span *ngIf="form.emailId.errors.pattern">Please enter Valid Email</span>
                                </div>
                            </div>
                        </div>
                        <div class="row martop20px">
                            <div class="col-md-8 col-xs-12">
                                <button type="submit" class="btn submitButton" (click)="onSubmit()">Send Link</button>
                            </div>
                        </div>
                    </form>
                    <div class="martop20px">
                        Return to <a routerLink="/signin"><strong>Sign In</strong></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>